export default "__VITE_ASSET__CxsXrue1__"